import React from 'react/addons';
import SelectOne from 'ofs/forms/inputs/simple-choice';
import FieldContainer from 'ofs/react/fields/fieldcontainer';

module.exports = React.createClass({

  handleSelect: function(event) {
    const {field, model} = this.props;
    model.set(field, event.target.value);
  },

  render: function() {
    const {label, options, name, defaultValue, error, placeholder} = this.props;

    return (
      <FieldContainer label={label}>
        <SelectOne allowEmpty={false}
                  onChange={this.handleSelect}
                  options={options}
                  name={name}
                  defaultValue={defaultValue}
                  placeholder={placeholder || '--'} />
        {error ? <p className="ofs-Input__ErrorMessage">{error}</p> : null}
      </FieldContainer>
    );
  }
});



/** WEBPACK FOOTER **
 ** ./static/js/onefinestay/react/fields/selectfield.jsx
 **/